module.exports = __webpack_public_path__ + "static/img/support1.816f5101.png";